import React from "react";
import { Container } from "react-bootstrap";
import "./ContactPageMap.css";

const ContactPageMap = () => {
  return (
    <Container fluid className="container ContactPageMap-container mb-5 mt-5">
      <h2 className="ContactPageMap-title" style={{ color: "#160F41" }}>
        Our Location
      </h2>
      <div className="ContactPageMap-mapWrapper">
        <iframe
          title="Google Map"
          className="ContactPageMap-iframe"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8354345096077!2d-75.5245173!3d39.1558988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c764aa7c4428d1%3A0x7b6820145593d386!2s8+The+Green+B,+Dover,+DE+19901,+USA!5e0!3m2!1sen!2sin!4v1643956123456!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </Container>
  );
};

export default ContactPageMap;
